import "./Navigation.css";
import "../css/common.css";
import {About} from "../pages/About";
import {Introduction} from "../pages/Introduction";
import {Token} from "../pages/Token";
import {RoadMap} from "../pages/RoadMap";
import {Constructor} from "../../utils/TypeUtils";
import {BasePage, getPageSetting} from "../pages/BasePage";
import {Connector} from "./Connector";
import {Common} from "../../app/Common";
import {FAQ} from "../pages/FAQ";

type NavItem = {
	name: string, clazz?: Constructor<BasePage>
}
const NavItems: NavItem[] = [{
	name: "ABOUT", clazz: About
}, {
	name: "POKERDAO NFT", clazz: Introduction
}, {
	name: "TOKEN", clazz: Token
}, {
	name: "ROADMAP", clazz: RoadMap
}, {
	name: "FAQ", clazz: FAQ
}];

function jump(nav: NavItem) {
	toggleMenu();

	if (!nav.clazz) return;
	const setting = getPageSetting(nav.clazz);

	let dom = document.getElementById(setting.id);
	dom?.scrollIntoView({behavior: "smooth", block: "start"})
}

const Menu = {
	menu: "menu",
	opened: false
};
function toggleMenu() {
	Menu.opened = !Menu.opened;

	const menu = document.getElementById(Menu.menu);
	console.log("toggle", menu);
	if (menu) menu.className = Menu.opened ? "opened" : "";
}

export function Navigation() {
	// @ts-ignore
	const Web = <div id="navigation" mode="web">
		<div className="title">POKERDAO</div>
		<div className="nav-items">
			<div className="deco-bar"/>
			{NavItems.map(item =>
				<div className="nav-item" onClick={() => jump(item)}>{item.name}</div>
			)}
		</div>
		<div className="icons">
			<img src={require("../../assets/discord-white.png")}
					 onClick={Common.toDiscord}/>
			<img src={require("../../assets/twitter-white.png")}
					 onClick={Common.toTwitter}/>
		</div>
		<Connector/>
	</div>

	// @ts-ignore
	const Mobile = <div id="navigation" mode="mobile">
		{/*<Connector/>*/}
		<img className="menu-button" src={require("../../assets/button1.png")} onClick={toggleMenu}/>
		<div id="menu">
			<img className="menu-button" src={require("../../assets/button2.png")} onClick={toggleMenu}/>
			<div className="nav-items">
				{NavItems.map(item =>
					<div className="nav-item" onClick={() => jump(item)}>{item.name}</div>
				)}
			</div>
			<div className="icons">
				<img src={require("../../assets/discord-white.png")}
						 onClick={Common.toDiscord}/>
				<img src={require("../../assets/twitter-white.png")}
						 onClick={Common.toTwitter}/>
			</div>
		</div>
	</div>

	return Common.isMobile ? Mobile : Web
}
